<template>
  <Layout>
    <div class="card">
      <div class="card-header">
        <h3 v-if="route.name === 'CardItemIconAdd'">
          {{ $t("t_add_card_item_icon") }}
        </h3>
        <h3 v-if="route.name === 'CardItemIconUpdate'">
          {{ $t("t_update_card_item_icon") }}
        </h3>
      </div>
      <div class="card-body">
        <div class="main-body">
          <el-form
            ref="ruleFormRef"
            :model="dataForm.value"
            :rules="rulesForm"
            label-width="200px"
            class="form-user"
          >
            <el-form-item label="Code" prop="code">
              <el-input
                v-model="dataForm.value.code"
                placeholder="Code"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="Icon" prop="file_id">
              <div class="card-item-icon">
                <div class="card-item-icon__image">
                  <img
                    v-if="srcIcon"
                    :src="srcIcon"
                    alt="card item icon"
                    height="32"
                    width="32"
                  />
                  <img v-else :src="NOICON" alt="" height="32" />
                </div>

                <label for="uploadIcon" class="card-item-icon__upload"
                  ><img src="../../assets/icon/upload_white.svg" alt="upload" />
                  <span>{{ $t("t-upload") }}</span></label
                >
                <input
                  type="file"
                  accept=".jpg, .png, .jpeg, .svg, .ico"
                  id="uploadIcon"
                  style="display: none"
                  @change="uploadIcon"
                  @click="onInputClick"
                />
                <div
                  class="card-item-icon__delete"
                  @click="clearIcon"
                  v-if="srcIcon"
                >
                  <i class="ri-delete-bin-6-line"></i>
                </div>
              </div>
            </el-form-item>

            <div class="text-center">
              <button
                type="button"
                class="btn btn-soft-secondary btn-border mx-3"
                @click="router.go(-1)"
              >
                {{ $t("t-back") }}
              </button>
              <el-button
                type="button"
                style="height: 40px"
                class="btn btn-secondary btn-border"
                @click="addCardItemIcon(ruleFormRef)"
                :loading="loadingBtn"
              >
                {{ $t("t-add") }}
              </el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script setup>
import Layout from "../../layouts/main.vue";
import toastr from "toastr";
import mushroom from "cem-primary-api";
import MethodService from "../../service/MethodService";
import Data from "./dataForm";
import { FormInstance } from "element-plus";
import Validate from "../../service/ValidService";
import { useRouter, useRoute } from "vue-router";
import { reactive, ref } from "vue";
import { useI18n } from "vue-i18n";
import NOICON from "@/assets/icon/none-icon.svg";

const { t } = useI18n();
const router = useRouter();
const route = useRoute();
const loadingBtn = ref(false);
const srcIcon = ref(null);
const dataForm = reactive({
  value: MethodService.copyObject(Data.dataForm),
});
const ruleFormRef = ref(FormInstance);

const rulesForm = reactive({
  code: [Validate.required, Validate.checkSpaceString],
  file_id: [Validate.required],
});
const uploadIcon = async () => {
  try {
    let nameImage = document.getElementById("uploadIcon").files[0]?.name;
     let typeImage = nameImage?.substring(nameImage.lastIndexOf(".")).toLowerCase();

    if (typeImage) {
      if (
        typeImage !== ".jpg" &&
        typeImage !== ".png" &&
        typeImage !== ".jpeg" &&
        typeImage !== ".svg" &&
        typeImage !== ".ico"
      ) {
        toastr.warning(t("t_select_format_image"));
      } else {
        try {
          let res = await mushroom.$file.uploadAsync({
            file: document.getElementById("uploadIcon").files[0],
          });

          if (res.result) {
            dataForm.value.file_id = res.result;
            srcIcon.value = MethodService.thumbIcon(res.result, 32);
            ruleFormRef.value.clearValidate("file_id");
          }
        } catch (e) {
          console.error(e);
          toastr.warning(t("t_upload_failed"));
        }
      }
    }
  } catch (e) {
    MethodService.showError(e.code);
  }
};
const onInputClick = (event) => {
  event.target.value = "";
};
const clearIcon = () => {
  srcIcon.value = "";
  dataForm.value.file_id = "";
};
const addCardItemIcon = async (formEl) => {
  if (!formEl) return;
  formEl.validate(async (valid) => {
    loadingBtn.value = true;
    if (valid) {
      const card_item_icon_object = {
        code: dataForm.value.code,
        file_id: dataForm.value.file_id,
      };
      try {
        const newId = await mushroom.card_item_icon.createAsync(
          card_item_icon_object
        );
        if (newId) {
          toastr.success(t("toastr_add_success"));
          router.go(-1);
        }
      } catch (error) {
        if (error.meta.field === "$unique_key") {
          toastr.error(t("toastr_had_name"));
        } else MethodService.showError(error.code);
      } finally {
        loadingBtn.value = false;
      }
    } else {
      loadingBtn.value = false;
      return false;
    }
  });
};
</script>
<style lang="scss" scoped>
.card-item-icon {
  display: flex;
  align-items: center;
  &__image {
    width: 32px;
    height: 32px;
  }
  &__upload {
    padding: 0 5px;
    cursor: pointer;
    margin-bottom: 0;
    margin-left: 15px;
    background-color: #f7b84b;
    height: 32px;
    border-radius: 5px;
    color: #fff;
    display: flex;
    align-items: center;
    span {
      padding-left: 5px;
    }
  }
  &__delete {
    margin-left: 10px;
    cursor: pointer;
    display: flex;
    &:hover i {
      color: red;
    }
  }
}
</style>
